import { CommonData } from '../common_schema'

export const rocksdbRWKVData: CommonData[] = [
  {
    name: 'Write operations (timeout)',
    mean: 'kv_write_operation_timeout:total.values.mean',
    std: 'kv_write_operation_timeout:total.values.std',
    location: 'TiKV-Details --> RocksDB kv --> Write operations (timeout)'
  },
  {
    name: 'Get Duration(p99)',
    mean: 'P99_kv_get_duration:total.values.mean',
    std: 'P99_kv_get_duration:total.values.std',
    location: 'TiKV-Details --> RocksDB kv --> Get Duration'
  },
  {
    name: 'Seek Duration(p99)',
    mean: 'P99_kv_seek_duration:total.values.mean',
    std: 'P99_kv_seek_duration:total.values.std',
    location: 'TiKV-Details --> RocksDB kv --> Seek Duration'
  },
  {
    name: 'Write Duration(p99)',
    mean: 'P99_kv_write_duration:total.values.mean',
    std: 'P99_kv_write_duration:total.values.std',
    location: 'TiKV-Details --> RocksDB kv --> Write Duration'
  },
  {
    name: 'Write WAL duration(p99)',
    mean: 'P99_kv_write_wal_duration:total.values.mean',
    std: 'P99_kv_write_wal_duration:total.values.std',
    location: 'TiKV-Details --> RocksDB kv --> Write WAL duration'
  },
  {
    name: 'WAL sync duration(p99)',
    mean: 'P99_kv_wal_sync_duration:total.values.mean',
    std: 'P99_kv_wal_sync_duration:total.values.std',
    location: 'TiKV-Details --> RocksDB kv --> WAL sync duration'
  },
  {
    name: 'Bytes / Write(p99)',
    mean: 'P99_kv_bytes_write:total.values.mean',
    std: 'P99_kv_bytes_write:total.values.std',
    location: 'TiKV-Details --> RocksDB kv --> Bytes / Write'
  },
  {
    name: 'Admin apply (remove peer)',
    mean: 'admin_apply_remove_peer:total.values.mean',
    std: 'admin_apply_remove_peer:total.values.std',
    location: 'TiKV-Details --> Raft admin --> Admin apply (remove peer)'
  },
  {
    name: 'Memtable hit',
    mean: 'kv_memtable_hit:total.values.mean',
    std: 'kv_memtable_hit:total.values.std',
    location: 'TiKV-Details --> RocksDB kv --> Memtable hit'
  },
  {
    name: 'Block cache hit',
    mean: 'kv_blockcache_hit:total.values.mean',
    std: 'kv_blockcache_hit:total.values.std',
    location: 'TiKV-Details --> RocksDB kv --> Block cache hit'
  },
  {
    name: 'SST read duration(p99)',
    mean: 'sst_read_duration:total.values.mean',
    std: 'sst_read_duration:total.values.std',
    location: 'TiKV-Details --> RocksDB kv --> SST read duration'
  }
]
